import { useState } from 'react';

import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { Text } from 'Components/Text/Text';
import { ICON_POSITIVE, ICON_SIGN_OUT } from 'Config/Icons';

import styles from './IdleTimeoutModal.module.css';

export interface IdleTimeoutModalProps {
    handleLogOut: () => void;
    onUserClickSessionKeepAlive: () => Promise<void>;
    timeoutCountdown: number;
}

export const IdleTimeoutModal = (props: IdleTimeoutModalProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const onUserContinueWorking = async () => {
        try {
            setIsLoading(true);
            await props.onUserClickSessionKeepAlive();
            setIsLoading(false);
        } catch (err) {
            console.error('Error: ', err);
        }
    };

    return (
        <Modal open header="Session Timeout">
            <div className={styles.contentContainer}>
                <Text variant="Text2">Your session will end in: {props.timeoutCountdown}</Text>
            </div>
            <div className={styles.contentContainer}>
                <Button variant="primary" onClick={onUserContinueWorking} fontAwesomeImage={ICON_POSITIVE} isLoading={isLoading} loadingText="Loading...">
                    Keep Working
                </Button>
                <Button variant="danger" onClick={props.handleLogOut} fontAwesomeImage={ICON_SIGN_OUT} disabled={isLoading}>
                    Log Out
                </Button>
            </div>
        </Modal>
    );
};
